import { DateTime } from 'luxon'

export function getPeriodoMesAtual() {
  const hoje = new Date()
  const dataInicial = new Date(hoje.getFullYear(), hoje.getMonth(), 1, 0, 0, 0)
  const dataFinal = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59)

  return { dataInicial, dataFinal }
}

export function getPeriodoUltimos30Dias() {
  const hoje = new Date()
  const dataFinal = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 23, 59, 59)
  const dataInicial = new Date(hoje)
  dataInicial.setDate(dataInicial.getDate() - 30)
  dataInicial.setHours(0, 0, 0, 0)

  return { dataInicial, dataFinal }
}

export function createMysqlPeriod(periodoInicial, periodoFinal) {
  // Periodo Inicial
  const dayInicial = periodoInicial.getDate()
  const monthInicial = periodoInicial.getMonth() + 1
  const yearInicial = periodoInicial.getFullYear()
  const periodoInicialMysql = `${yearInicial}-${monthInicial}-${dayInicial} 00:00:00`

  // Periodo Final
  const dayFinal = periodoFinal.getDate()
  const monthFinal = periodoFinal.getMonth() + 1
  const yearFinal = periodoFinal.getFullYear()
  const periodoFinalMysql = `${yearFinal}-${monthFinal}-${dayFinal} 23:59:59`

  return { periodoInicialMysql, periodoFinalMysql }
}

export function parseToMysqlFormat(date) {
  let day, month, year
  if (typeof date === 'string') {
    ;[day, month, year] = date.split('/')
    if (day === '' || month === '' || year === '') return undefined
  } else if (typeof date === 'object') {
    day = `${date.getDate()}`.padStart(2, '0')
    month = `${date.getMonth() + 1}`.padStart(2, '0')
    year = date.getFullYear()
  } else {
    throw new Error('Data no formato desconhecido')
  }
  return `${year}-${month}-${day}`
}

export function parseToMysqlFormatWithTime(date) {
  if (typeof date !== 'object' || !(date instanceof Date)) {
    throw new Error('Data no formato desconhecido')
  }
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export function parseToMysqlFormatWithTime00(date) {
  if (typeof date !== 'object' || !(date instanceof Date)) {
    throw new Error('Data no formato desconhecido')
  }
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  return `${year}-${month}-${day} 00:00:00`
}

export function parseToMysqlFormatWithTime23(date) {
  if (typeof date !== 'object' || !(date instanceof Date)) {
    throw new Error('Data no formato desconhecido')
  }
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  return `${year}-${month}-${day} 23:59:59`
}

export function parseToMysqlTimeFormat(time) {
  let hour, minutes
  if (typeof time === 'string') {
    ;[hour, minutes] = time.split(':')
    if (hour === '' || minutes === '') return undefined
  } else if (typeof time === 'object') {
    hour = time.getHours()
    minutes = time.getMinutes()
  } else {
    throw new Error('Hora no formato desconhecido')
  }
  return `${hour}:${minutes}`
}

export function convertToJsDate(dateString) {
  if (typeof dateString === 'string') {
    const [day, month, year] = dateString.split('/')
    if (day === '' || month === '' || year === '') return undefined
    return new Date(year, month - 1, day)
  } else {
    throw new Error('A data deve ser do tipo string DD/MM/YYYY')
  }
}

export function convertToFormatedDateString(dateString) {
  if (typeof dateString === 'string') {
    const s = dateString.split('T')
    if (s.length === 2) {
      const d = s[0].split('-')
      const [ano, mes, dia] = d
      return `${dia}/${mes}/${ano}`
    }
  }
  return dateString
}

export function formatDateToLocale(value, inputFormat) {
  const dataBrasilia = DateTime.fromFormat(value, inputFormat, {
    zone: 'America/Sao_Paulo',
  })
  const fusoUsuario = Intl.DateTimeFormat().resolvedOptions().timeZone
  const dataUsuario = dataBrasilia.setZone(fusoUsuario)
  return dataUsuario
}

export function formatIsoDateToLocale(value) {
  const dataBrasilia = DateTime.fromISO(value, {
    zone: 'America/Sao_Paulo',
  })
  const fusoUsuario = Intl.DateTimeFormat().resolvedOptions().timeZone
  const dataUsuario = dataBrasilia.setZone(fusoUsuario)
  return dataUsuario
}

export function formatJsDateToLocale(value) {
  const dataBrasilia = DateTime.fromJSDate(value, {
    zone: 'America/Sao_Paulo',
  })
  const fusoUsuario = Intl.DateTimeFormat().resolvedOptions().timeZone
  const dataUsuario = dataBrasilia.setZone(fusoUsuario)
  return dataUsuario
}

export function getPeriodoFromLastXDays(xDays, diasParaFrente = 0) {
  // Retorna o periodo dos últimos X dias
  // Por exemplo: retorna o período referente aos últimos 60 dias
  // Opcionalmente estende a data final em N dias para frente

  // Data final é hoje mais a quantidade de dias para frente
  const dataFinal = new Date()
  dataFinal.setDate(dataFinal.getDate() + diasParaFrente)

  // Data inicial é hoje menos a quantidade de dias
  const dataInicial = new Date()
  dataInicial.setDate(dataInicial.getDate() - xDays)

  return {
    pInicial: dataInicial,
    pFinal: dataFinal,
  }
}
